import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AnagraficheApi } from "../data/apis/AnagraficheApi";

export const incubatoiDataSource = new CustomStore({
    key: "id",
    loadMode : 'raw',
    load: (loadOptions) => {
      const api = new AnagraficheApi(apiConfiguration);
    
        return api.getIncubatoi();
    },
  
    byKey: (key) => {
      const api = new AnagraficheApi(apiConfiguration);
        return api.getIncubatoioById({idIncubatoio:key});
    },
  
    insert: (values) => {
      const api = new AnagraficheApi(apiConfiguration);
      return api.insertIncubatoio({
        incubatoioCreateDTO: values
      });
    },
  
    update: (key, values) => {
      const api = new AnagraficheApi(apiConfiguration);

      return api.updateIncubatoio({
        idIncubatoio: key,
        incubatoioUpdateDTO: values
      });
    },
  
     remove: (key) => {
      const api = new AnagraficheApi(apiConfiguration);
      return api.deleteIncubatoio({
        idIncubatoio: key
      });
     }
  });